"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.compoundFromName = void 0;
const cross_fetch_1 = __importDefault(require("cross-fetch"));
const Compound_1 = require("../Compound");
const handleError_1 = require("./handleError");
async function compoundFromName(smiles, options = {}) {
    const { cache } = options;
    let compounds;
    if (cache?.(smiles)) {
        compounds = cache(smiles);
    }
    else {
        const encodedName = encodeURIComponent(smiles);
        const moleculeResponse = await (0, cross_fetch_1.default)(`https://pubchem.ncbi.nlm.nih.gov/rest/pug/compound/name/${encodedName}/json`);
        compounds = (await moleculeResponse.json()).PC_Compounds;
        if (cache) {
            cache(smiles, compounds);
        }
    }
    (0, handleError_1.checkCompoundsResult)(compounds);
    return new Compound_1.Compound(compounds[0], { cache });
}
exports.compoundFromName = compoundFromName;
//# sourceMappingURL=compoundFromName.js.map